import {
    SET_FILTERS,
    SET_FILTER_TYPES,
    SET_ITEM_FILTER,
    SET_FILTERED_ITEMS,
    SET_FILTERED_MENU,
} from "../actions/filterAction";
import { RESET_FOR_MODEL_SELECTOR } from "../actions/sessionActions";
import { ItemFilter } from "../models/itemFilter";
import FilterState from "../stateTypes/filterState";

const initialState: FilterState = {
    itemFilter: new ItemFilter("sv"),
    filterTypes: {},
    filters: null,
    filteredItems: [],
    selectedFilterItems: [],
    currentTabName: null,
    accountFilterTexts: {},
    filteredMenu: "",
};

const filterReducer = (state: FilterState = initialState, action: any = {}) => {
    switch (action.type) {
        case SET_ITEM_FILTER:
            return {
                ...state,
                itemFilter: action.itemFilter,
            };
        case SET_FILTERS:
            return {
                ...state,
                filters: action.filters,
                itemFilter: action.itemFilter,
            };
        case SET_FILTER_TYPES:
            return {
                ...state,
                filterTypes: action.filterTypes,
                accountFilterTexts: action.accountFilterTexts,
            };
        case SET_FILTERED_ITEMS:
            return {
                ...state,
                filteredItems: action.filteredItems,
            };
        case SET_FILTERED_MENU:
            return {
                ...state,
                filteredMenu: action.filteredMenu,
            };
        case RESET_FOR_MODEL_SELECTOR:
            return {
                ...initialState,
                // Filter type definitions come from CREATE_SESSION and are reused when LOAD_CONFIG keeps the session alive.
                filterTypes: state.filterTypes,
                accountFilterTexts: state.accountFilterTexts,
            };
        default:
            return state;
    }
};

export default filterReducer;
